import { render, staticRenderFns } from "./step_1.vue?vue&type=template&id=5350942a&scoped=true&"
import script from "./step_1.vue?vue&type=script&lang=js&"
export * from "./step_1.vue?vue&type=script&lang=js&"
import style0 from "./step_1.vue?vue&type=style&index=0&id=5350942a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350942a",
  null
  
)

export default component.exports